import { useState } from 'react';

import '../fabric.css'
import { extractUniqueFabricAttributes } from '../../Functions';

function FilterFabric({Fabric, useFabric, setUseFabric, useFilter, currentFilters, setCurrentFilters}) {

    return ( 
        <div className="f-filter">
                            
        <div className="f-filterBody">
            <label className="txt-font f-filter-title"><b>Filters</b></label>

            {useFilter && useFilter.map((value, key)=>{
                return(
                    <div className="f-fil-comp hori_center">
                        <label className="txt-font1"
                            style={{"margin":"20px 0px"}}
                        >{value["type"]}</label>
                        
                        {value["q"] === 1 ? <div class="container">
                            <a data-toggle="tooltip" title="Hooray!"><div class="row gx-0">
                                {value["attr"].map((val, k)=>{
                                    return(
                                        <div class={`col-3 f-balls mb-2 ${currentFilters.Color && currentFilters.Color.includes(val) ? "f-c-active" : ""}`}
                                            
                                            onClick={()=>{
                                                let newArr = [];
                                                if(currentFilters && currentFilters.Color){
                                                    newArr = [...currentFilters.Color]
                                                }
                                                if(newArr.includes(val)){
                                                    newArr = newArr.filter(eles => eles !== val)
                                                } else {
                                                    newArr.push(val)
                                                }
                                                setCurrentFilters({...currentFilters, ...{Color:[...newArr]}})
                                            }}
                                        >

                                            <div style={{"background":val}} className="both_center">

                                            </div>
                                            {/* 1 of 2 */}
                                        </div>
                                    )
                                })}
                            </div></a>
                        </div>
                        :value["q"] === 0 ? <>
                            {value["attr"].map((val, k)=>{
                                    return(
                                        <div className='f-c-comp hori_center'>
                                            <label>{val[0].toUpperCase()+ val.slice(1, val.length)}</label>
                                            <input class="form-check-input f-c-i" type="checkbox" value={val.replace(" ", "_")} id="flexCheckDefault" 
                                                style={{"border":"1px solid black"}} onChange={(e)=>{
                                                    console.log("printing currentFilyters" , currentFilters)
                                                    let newArr = [];
                                                    if(currentFilters&& currentFilters[value]){
                                                        newArr = [...currentFilters[value]]
                                                    }
                                                    
                                                    if(e.target.checked){
                                                        console.log("checked")
                                                        newArr.push(val)
                                                    } else {
                                                        newArr = newArr.filter(eles => eles != val)
                                                    }
                                                    setCurrentFilters({...currentFilters, ...{[value.type]:[...newArr]}})
                                                }}
                                            />
                                        </div>
                                    )
                                })}
                        </>
                        : <>
                            <div className='f-c-comp hori_center'>
                                            <label className={`filter_price_custom
                                                ${currentFilters.sortBy && currentFilters.sortBy === "highToLow" ? 'bg_blue'
                                                    : "bg_orange"
                                                }
                                            `}
                                                onClick={(e)=>{
                                                    if(currentFilters.sortBy && currentFilters.sortBy === "highToLow"){
                                                        setCurrentFilters({...currentFilters, ...{"sortBy":"lowToHigh"}})
                                                    } else {
                                                        setCurrentFilters({...currentFilters, ...{"sortBy":"highToLow"}})
                                                    }
                                                }}
                                            >
                                                {currentFilters.sortBy && currentFilters.sortBy === "highToLow" ? "High to Low" : "Low to High"}
                                            </label>

                                            {/* <input class="form-check-input f-c-i" type="checkbox" value="" id="flexCheckDefault" 
                                                style={{"border":"1px solid black"}}
                                                
                                            /> */}
                            </div>
                            {/* <div className='f-c-comp hori_center'>
                                            <label>Low to High</label>
                                            <input class="form-check-input f-c-i" type="checkbox" value="" id="flexCheckDefault" 
                                                style={{"border":"1px solid black"}}
                                                onChange={(e)=>{
                                                    setCurrentFilters({...currentFilters, ...{"sortBy":"LowToHigh"}})
                                                }}
                                            />
                            </div> */}
                            
                        </>
                        }

                        
                        
                    </div>
                )
            })}

            
        </div>
    </div> );
}

export default FilterFabric;
